import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";

import { ConfirmationService } from "primeng/api";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { DynamicDialogModule } from "primeng/dynamicdialog";
import { CalendarModule } from "primeng/calendar";
import { TableModule } from "primeng/table";
import { ButtonModule } from "primeng/button";
import { MultiSelectModule } from "primeng/multiselect";
import { DropdownModule } from "primeng/dropdown";
import { InputNumberModule } from "primeng/inputnumber";
import { RadioButtonModule } from "primeng/radiobutton";
import { AccordionModule } from "primeng/accordion";
import { SchoolselectorModule } from "../schoolselector/schoolselector.module";

import { AppSharedModule } from "../../shared/app-shared.module";
import { VisitorRoutes } from "./Visitor-routes";
import { VisitorComponent } from "./index";

import { VisitorDesignComponent } from "./visitordesign/visitordesign.component";

import { FacilityLocationMaintComponent } from "./facilitylocationmaint/facilitylocationmaint.component";
import { LocationAddComponent } from "./facilitylocationmaint/locationadd/locationadd.component";
import { LocationEditComponent } from "./facilitylocationmaint/locationedit/locationedit.component";

import { VisitorSelectorComponent } from "./visitorselector/visitorselector.component";

import { ViewVisitorComponent } from "./viewvisitor/viewvisitor.component";
import { PrintVisitorComponent } from "./viewvisitor/printvisitor/printvisitor.component";
import { EditVisitorComponent } from "./viewvisitor/editvisitor/editvisitor.component";
import { VerifyVisitorComponent } from "./viewvisitor/verifyvisitor/verifyvisitor.component";
import { ImportBlockComponent } from "./viewvisitor/importblock/importblock.component";

import { ViewLogComponent } from "./viewlog/viewlog.component";
import { PrintVisitorsLogComponent } from "./viewlog/printvisitorslog/printvisitorslog.component";

import { ViewVisitorDetailComponent } from "./viewvisitordetail/viewvisitordetail.component";

import { PersonSelectorModule } from "../personselector/personselector.module";

import { DataService_visitorselector } from "./visitorselector/shared/data.service";
import { DataService_visitordesign } from "./visitordesign/shared/data.service";
import { DataService_facilitylocationmaint } from "./facilitylocationmaint/shared/data.service";
import { DataService_viewvisitor } from "./viewvisitor/shared/data.service";
import { DataService_viewlog } from "./viewlog/shared/data.service";
import { DataService_viewvisitordetail } from "./viewvisitordetail/shared/data.service";
import { ExportBlockListComponent } from "./viewvisitor/export-block-list/export-block-list.component";

@NgModule({
	declarations: [
		VisitorComponent,
		VisitorSelectorComponent,
		VisitorDesignComponent,
		FacilityLocationMaintComponent,
		LocationAddComponent,
		LocationEditComponent,
		ViewVisitorComponent,
		PrintVisitorComponent,
		EditVisitorComponent,
		VerifyVisitorComponent,
		ImportBlockComponent,
		ViewLogComponent,
		PrintVisitorsLogComponent,
		ViewVisitorDetailComponent,
		ExportBlockListComponent,
	],
	imports: [
		CommonModule,
		FormsModule,
		AppSharedModule,
		BrowserAnimationsModule,
		MatSlideToggleModule,
		RouterModule,
		PersonSelectorModule,
		ConfirmDialogModule,
		DynamicDialogModule,
		CalendarModule,
		TableModule,
		ButtonModule,
		MultiSelectModule,
		DropdownModule,
		InputNumberModule,
		RadioButtonModule,
		AccordionModule,
		SchoolselectorModule,
	],
	providers: [
		ConfirmationService,
		DataService_visitorselector,
		DataService_visitordesign,
		DataService_facilitylocationmaint,
		DataService_viewvisitor,
		DataService_viewlog,
		DataService_viewvisitordetail,
	],
})
export class VisitorModule {}
